import { render, staticRenderFns } from "./CreateCallbackDialog.vue?vue&type=template&id=5bc80e22&scoped=true&"
import script from "./CreateCallbackDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateCallbackDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc80e22",
  null
  
)

export default component.exports